<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({}),
}
</script>

<style>
/* Apply only on mobile */
@media (max-width: 600px) {
  .wg_logo_game {
    height: 30px;
  }
  .wg_modal_score {
    font-size: 15px !important;
  }
}

.games-table {
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.games-table th {
  background: #175a40 !important;
  color: #fff !important;
  text-transform: none;
  padding: 16px 12px;
  white-space: nowrap;
  border-bottom: 2px solid #e0e0e0;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
}
</style>
